import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import VideoRecorder from "react-video-recorder";
import Title from "designs/v1/components/Title";
import Button from "designs/v1/components/Button";
import {
  uploadReactivateVisualVerifyApi,
  submitReactivateVisualVerifyApi,
  reactivateForSendPdfApi,
  reactivateForEsignApi,
  sendSessionStartMail,
} from "designs/v1/pages/ModifyKyc/services";

const VisualVerification = ({
  activeUserDetail,
  isLoading,
  setIsLoading,
  setStep,
}) => {
  const { inputLabelColor, inputError } = useSelector((state) => state.theme);
  const [videoBlob, setVideoBlob] = useState(null);
  const [showImgModal, setImgShowModal] = useState({
    show: false,
    data: "",
  });
  const [sum, setSum] = useState("");
  const [tempSum, setTempSum] = useState(0);
  const [captchaResult, setCaptchaResult] = useState([]);
  const [captchaIsValid, setCaptchaIsValid] = useState(false);
  const [location, setLocation] = useState("");
  const [number, setNumber] = useState({
    num1: "",
    num2: "",
  });
  //send email or sms link
  const [sendLinkState, setSendLinkState] = useState({
    showLinkToSend: false,
    isLinkSendLoading: false,
  });
  const brokerID = window.sessionStorage.getItem("broker_id");
  const authToken = window.sessionStorage.getItem("token");
  const docName = window.sessionStorage.getItem("doc_name");
  const baseURL = window.location.origin.toString();

  useEffect(() => {
    getGeolocation();
  }, []);

  useEffect(() => {
    reloadCaptcha();
  }, []);

  useEffect(() => {
    const total = number.num1 + number.num2;
    setTempSum(total);
    let random,
      arr = [total, total + 2];
    random = randomArrayShuffle(arr);
    setCaptchaResult(random);
  }, [number]);

  const randomArrayShuffle = (array) => {
    let currentIndex = array.length,
      temporaryValue,
      randomIndex;
    while (0 !== currentIndex) {
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }
    return array;
  };

  const getGeolocation = async () => {
    try {
      const resp = await fetch("https://geolocation-db.com/json/");
      const json = await resp.json();
      setLocation(json);
    } catch (error) {
      console.error(error);
    }
  };

  const reloadCaptcha = () => {
    setNumber({
      num1: Math.floor(Math.random() * 2) + 1,
      num2: Math.floor(Math.random() * 2) + 1,
    });
    setCaptchaIsValid("");
  };

  const handleStopVideo = () => {
    setVideoBlob(null);
    setSum(false);
  };

  const submitCaptcha = (e) => {
    setSum(e.target.value);
    let parseNum = parseInt(e.target.value);
    if (tempSum === parseNum) {
      setCaptchaIsValid(true);
      handleVerification();
    } else {
      setCaptchaIsValid(false);
    }
  };

  const handleCloseImgModal = () => {
    setVideoBlob(null);
    setSum(false);
    setImgShowModal({
      show: false,
      data: null,
    });
    return toast.error("Error: Please upload new video.");
  };

  const handleVerification = async () => {
    if (!videoBlob) {
      return toast.error("Error: Please try again.");
    }
    setIsLoading(true);
    const formData = new FormData();
    formData.append("files", videoBlob);
    formData.append("ip", location.IPv4);
    formData.append("question", `${number.num1} + ${number.num2}`);
    formData.append("answer", tempSum);
    try {
      await uploadReactivateVisualVerifyApi(formData);
      // toast.success(resp?.data?.message);
      handleSubmit();
      // setIsLoading(false);
      // setImgShowModal({
      //   show: true,
      //   data: resp?.data?.data,
      // });
    } catch (error) {
      const { data } = error.response || {};
      toast.error(data.message || "Internal server error!");
      setIsLoading(false);
    }
  };

  const handleSubmit = async () => {
    // setIsLoading(true);
    try {
      await submitReactivateVisualVerifyApi();
      toast.success("Visual verification saved successfully.");
      try {
        const payload = {
          request_type: "Reactivation",
          doc_name: activeUserDetail?.request_number,
        };
        await Promise.all([
          reactivateForSendPdfApi(payload),
          reactivateForEsignApi(payload),
        ]);
        setIsLoading(false);
        setStep("ESignature");
        toast.success("Request for Esign submitted successfully.");
      } catch (error) {
        setIsLoading(false);
        const { data } = error.response || {};
        toast.error(data.message || "Internal server error!.");
      }
    } catch (error) {
      const { data } = error.response || {};
      toast.error(data.message || "Internal server error!");
      setIsLoading(false);
    }
  };

  const onSendEmail = async () => {
    setSendLinkState((prev) => ({ ...prev, isLinkSendLoading: true }));
    try {
      await sendSessionStartMail();
      setSendLinkState({
        showLinkToSend: true,
        isLinkSendLoading: false,
      });
    } catch (error) {
      const { data } = error.response || {};
      toast.error(data.message || "Internal server error!");
      setSendLinkState((prev) => ({ ...prev, isLinkSendLoading: false }));
    }
  };

  return (
    <>
      <Title title="Visual Verification" />
      <div className="row">
        <div className="col-md-9">
          <div
            style={{ background: "rgba(12,171,196, 0.1)", borderRadius: 20 }}
            className="px-5 py-3"
          >
            <div style={{ color: inputLabelColor, fontWeight: "bold" }}>
              Capture Video
            </div>
            <div
              style={{ color: inputLabelColor, fontSize: 12 }}
              className="my-1"
            >
              Ensure that your face is clearly visible in the video. (4 to 5
              seconds of video is fine)
            </div>
            <div
              style={{ color: "#F00", fontSize: 14, fontWeight: "500" }}
              className="mb-2"
            >
              Note: Rotate face 45 degree left and 45 degree right.
            </div>
            <div className="video">
              <VideoRecorder
                replayVideoAutoplayAndLoopOff={true}
                onRecordingComplete={(blob) => setVideoBlob(blob)}
                onStopReplaying={() => handleStopVideo()}
                timeLimit={10000}
              />
            </div>
            {videoBlob && (
              <div className="mt-2">
                <span
                  className="numbrs"
                  style={{ color: inputLabelColor }}
                >
                  What is {number.num1} + {number.num2} = ?
                </span>
                {captchaResult.map((item, index) => {
                  return (
                    <div
                      key={index}
                      className="form-check mx-1"
                    >
                      <input
                        type="radio"
                        className="form-check-input"
                        value={item}
                        checked={item === sum}
                        onChange={submitCaptcha}
                      />{" "}
                      <label className="custom-control-label mx-2">
                        {item}
                      </label>
                    </div>
                  );
                })}
                {sum && !captchaIsValid && (
                  <div
                    className="mt-1"
                    style={{ color: inputError }}
                  >
                    Invalid captcha
                  </div>
                )}
              </div>
            )}
            <div
              className="mt-2"
              style={{ textAlign: "right" }}
            >
              <button
                className="btn"
                onClick={() => onSendEmail()}
              >
                <small>
                  {sendLinkState.isLinkSendLoading ? (
                    <div
                      className="spinner-border text-dark text-sm"
                      role="status"
                    >
                      <span className="sr-only">Loading...</span>
                    </div>
                  ) : (
                    "Send link as Email"
                  )}
                </small>
              </button>
            </div>
          </div>
          {!docName && (
            <div className="d-flex form-group my-4">
              <div className="">
                <Button
                  type="button"
                  title="Back"
                  handleClick={() => setStep("IncomeProof")}
                />
              </div>
            </div>
          )}
        </div>
      </div>
      <Modal show={sendLinkState.showLinkToSend}>
        <Modal.Header>Send link as email</Modal.Header>
        <Modal.Body>
          <small>
            We have sent you an email with link. kindly check your email.
            <br /> <br />
            Or You can use the below link to share with your other device with
            camera.
            <br />
            <br />
          </small>
          <pre>
            <code>
              {baseURL +
                "/m/" +
                brokerID +
                "/" +
                authToken +
                "/" +
                activeUserDetail?.request_number}
            </code>
          </pre>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-danger"
            onClick={() =>
              setSendLinkState((prev) => ({ ...prev, showLinkToSend: false }))
            }
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showImgModal.show}
        onHide={handleCloseImgModal}
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="d-flex align-item-center justify-content-center">
            <img
              src={showImgModal.data?.url}
              className="img-fluid"
              alt=""
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            title="Cancel"
            handleClick={() => handleCloseImgModal()}
          />
          <Button
            title="Submit"
            handleClick={() => handleSubmit()}
          />
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default VisualVerification;
